/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module IpcTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Ipc {
    [k: string]: any;
}
/**
 * This interface was referenced by `Ipc`'s JSON-Schema
 * via the `definition` "IpcMessage".
 */
export interface IpcMessage {
    recipient?: IpcTargets;
    sender?: IpcTargets;
    content: string;
    type: string;
}
/**
 * This interface was referenced by `Ipc`'s JSON-Schema
 * via the `definition` "PushParameters".
 */
export interface PushParameters {
    message: IpcMessage;
}
/**
 * This interface was referenced by `Ipc`'s JSON-Schema
 * via the `definition` "LoginStatusParameters".
 */
export interface LoginStatusParameters {
    data?: {
        [k: string]: any;
    };
}
/**
 * This interface was referenced by `Ipc`'s JSON-Schema
 * via the `definition` "EulaAcceptedParameters".
 */
export interface EulaAcceptedParameters {}

/**
 * This interface was referenced by `Ipc`'s JSON-Schema
 * via the `definition` "IpcTargets".
 */
export enum IpcTargets {
    GfnMall = 'mallclient',
    GfnStreamer = 'streamer',
    GfnUpdater = 'selfupdater'
}


}
